import { CommonKeys } from "../../../common/enums";
import type { StammElement } from "./StammElement";

export const STAMM_DYNFIELD_TYPE = "AM_Services.Domain.Models.Formulare.StammElementDynField, AM_Services.Domain.Standard";

export const FormularGroupStammStammElementDynFieldSchema = {
    $id: "FormularGroupStammStammElementDynFieldSchema",
    title: "FormularGroupStammStammElementDynField Schema",
    type: "object",
    allOf: [
        { $ref: "FormularGroupStammStammElementBaseSchema" },
        {
            type: "object",
            properties: {
                [CommonKeys.Type]: { const: STAMM_DYNFIELD_TYPE },
                FieldID: { type: "number", nullable: true }
            }
        }
    ],
};

export interface StammElementDynField extends StammElement {
    FieldID: string;
}
